import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import { FormControl, FormHelperText, MenuItem } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles({
  container: {
    width: '160px',
    backgroundColor: 'white'
  },
  containerSelect: {
    paddingTop: '8px',
    paddingBottom: '8px'
  }
});

export default function CustomSelect ({ value = '', onChange, menuItems, label, ...props }) {
  const [state, setState] = useState(value);
  const [textHelper, setTextHelper] = useState('');
  const classes = useStyles();
  const { t } = useTranslation();

  const handleTextHelper = (menuItems, value) => {
    const item = menuItems.find((item) => item.value === value);
    return item ? item.textHelper : '';
  };

  const handleChange = (event) => {
    if (typeof event.target.value === 'object') {
      event.target.value = event.target.value.filter((value) => value !== '');
    }
    setState(event.target.value);
    onChange(event.target.value);
    if (menuItems) { setTextHelper(handleTextHelper(menuItems, event.target.value)); }
  };

  return (
    <FormControl variant='outlined' >
      <Select
        {...props}
        displayEmpty
        value={state}
        onChange={handleChange}
        className={classes.container}
        classes={{ select: classes.containerSelect }} >
        <MenuItem value='' disabled>
          {label || t('exportData:defaultLabel')}
        </MenuItem>
        {menuItems.map((item) => (
          <MenuItem key={item.value} value={item.value}>{t(`exportData:${item.label}`)}</MenuItem>
        ))}
      </Select>
      {textHelper && <FormHelperText>{t(`exportData:${textHelper}`)}</FormHelperText>}
    </FormControl>
  );
}

CustomSelect.propTypes = {
  multiple: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  onChange: PropTypes.func.isRequired,
  menuItems: PropTypes.array.isRequired,
  htmlFor: PropTypes.string,
  label: PropTypes.string
};
